import { z } from 'zod';

import { QuestionnaireTypeCodeZod } from './questionnaire-type-code';

import { QInstanceStatusZod } from 'types/zod/qinstance-status';

export const WidgetZod = z.object({
    type: z.string(),
    address_types: z.array(z.string()).optional(),
    child: z.boolean().optional(),
    role_type_code: z.string().optional(),
    visibility_code: z.string().optional(),
    format: z.string().optional(),
    row_format: z.string().optional(),
    source: z.string().optional(),
    subset: z.array(z.string()).optional(),
    row_where: z.string().optional(),
    min_size: z.number().optional(),
    max_size: z.number().optional(),
    filter: z.string().optional(),
    max_value: z.number().optional(),
    min_value: z.number().optional(),
    max_decimal: z.number().optional(),
    inline_edit: z.string().optional(),
    inline_total_required: z.number().optional(),
    require: z.boolean().optional(),
    questionnaire_type: QuestionnaireTypeCodeZod.optional(),
    helped_text: z.string().optional(),
    plans: z.array(z.string()).optional(),
    availability_in_plans: z.array(z.boolean()).optional(),
    participant_id: z.string().optional(),
    save_type: z.string().optional(),
    required_dob: z.boolean().optional(),
    show_calendar: z.boolean().optional(),
    label: z.string().optional(),
    appearance: z.string().optional(),
    validation_regex: z.string().optional(),
    validation_regex_flags: z.string().optional(),
    is_final: z.boolean().optional(),
    status: QInstanceStatusZod.optional(),
    default_checked: z.boolean().optional(),
    section: z.string().optional(),
    format_participant_info: z.string().optional(),
    go_to_add_on_empty: z.boolean().optional(),
    jump_to: z.string().optional(),
    skip_with_id: z.string().optional(),
    delete_empty_answer_objects: z.boolean().optional(),
    path_to_assessment: z.string().optional(),
    path: z.string().optional(),
    required_age: z.boolean().optional(),
    spouse: z.boolean().optional(),
    last_diagram_of_section: z.boolean().optional(),
    sort_by: z.string().optional(),
    participant_type: z.string().optional(),
    state_selector: z.boolean().optional(),
    hide_back_button: z.boolean().optional(),
    auto_go_to_following: z.boolean().optional(),
    value: z.string().optional(),
    replace: z.boolean().optional(),
    auto_open_community: z.boolean().or(z.string()).optional(),
    disallow_advisors: z.boolean().optional(),
    do_not_delete_hidden: z.boolean().optional(),
});
export type Widget = z.infer<typeof WidgetZod>;
